<template>
  <div
    class="input-wrapper relative"
    :class="{ 'error': showError }"
  >
    <label
      v-if="labelText"
      class="text-sm font-medium text-secondary"
      for="password-input"
    >
      <span>{{ labelText }}</span>
      <span v-if="showError" class="text-error-primary">- {{ errorText }}</span>
    </label>
    <input
      v-model="password"
      :type="inputType"
      placeholder="Enter password"
      @focus="onFocus"
      @blur="onBlur"
    />
    <button class="button-reset icon-small" @click="showPassword = !showPassword">
      <icon
        v-if="showPassword"
        name="eye-on"
      ></icon>
      <icon
        v-else
        name="eye-off"
      ></icon>
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
   labelText: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focused: false,
      showPassword: false,
      password: '',
    };
  },
  computed: {
    inputType() {
      return this.showPassword ? 'text' : 'password';
    },
    showError() {
      return this.errorText && !this.focused;
    },
  },
  created() {
    this.password = '';
  },
  methods: {
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
      this.$emit('input', this.password);
    },
  },
};
</script>

<style scoped lang="scss">
.input-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  margin-bottom: 1rem;

  &.error {
    label {
      color: var(--text-error-primary);
    }

    input {
      border-color: var(--text-error-primary);
    }
  }

  input {
    padding: 0.75rem;
    background-color: white;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-primary);
    margin-top: rem-calc(6);
    font-size: 1rem;
    color: #333;

    &:focus {
      outline: none;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }
}

.icon-small {
  position: absolute;
  right: rem-calc(12);
  top: rem-calc(42);
  color: var(--text-secondary);
}

.relative {
  position: relative;
}
</style>
